module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch01"
  }, [_vm._v("1")]), _vm._v(" Ingredient Glossary, Dip Tips, and Deep-Frying Techniques for Chips")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch02"
  }, [_vm._v("2")]), _vm._v(" Vegetable and Herb Dips")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Artichoke-Parmesan Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Red Pepper, Sun-Dried Tomato, and Basil Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumber and Radish Raita")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feta Compli")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Butternut Squash Dip with Crème Fraîche")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Mushroom Spread with Onion, Caraway, and Dill")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Your Mother’s Onion Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dip into India")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig and Kalamata Olive Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Eggplant and Garlic Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balsamic Roasted Tomato Spread with Garlic Olive Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can’t Believe It’s Peanut Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch03"
  }, [_vm._v("3")]), _vm._v(" Salsas and Guacamoles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire-Roasted Corn and Sweet Red Pepper Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paola’s Mango Salsa with Cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Fresh Tomato Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Bean Salsa with Cilantro and Chiles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple-Habañero Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Sweet Pepper, White Onion, and Basil Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guacamole with Fire-Roasted Tomatoes and Chiles, Red Onion, and Orange")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guacamole with Roasted Anaheim Chiles and Lime")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch04"
  }, [_vm._v("4")]), _vm._v(" Cheese, Bean, Legume, and Tofu Dips")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goat Cheese, Chive, and Pistachio Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Cheese Dip with Chives")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farmhouse Cheddar and Tomato Fondue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Tofu Pâté")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Chickpea Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Black Bean Dip with Chorizo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Bean Dip with Lots of Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlicky Red Lentil Purée")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch05"
  }, [_vm._v("5")]), _vm._v(" Meat and Seafood Dips")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shanghai Shrimp Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Tuna Mousse")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon-Chanted Evening")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just for the Halibut")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Crab Dip with Cilantro and Chives")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chorizo Chile Con Queso")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Rose’s Chicken Liver Pâté")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch06"
  }, [_vm._v("6")]), _vm._v(" Dessert Dips")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Garcia Takes a Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Mocha Mascarpone Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twistin’ in the Tropics Fruit Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel and Dark Rum Fondue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bittersweet Chocolate and Grand Marnier Fondue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime Mousse Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tch07"
  }, [_vm._v("7")]), _vm._v(" Crudités, Chips, Crisps, and Other Dippers")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crudités")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pita Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crostini")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salty or Sweet Wonton Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bagel Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan Breadsticks")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Tortilla Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Tortilla Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart-Shaped Apple-Cinnamon Tortilla Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toasted Pound Cake Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Chocolate Chunk Brownie Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/toc07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/table",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Table of Equivalents")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0